<div
  class="admin-section-header"
  [class.admin-section-header__readonly]="client"
  [class.collapsed]="appointmentCollapsed"
>
  <div
    [class.collapsed]="appointmentCollapsed"
    class="d-flex"
    (click)="appointmentCollapsed = !appointmentCollapsed"
  >
    <div>
      Afspraak:
      {{
        subProject.projectPlacement.appointment &&
        subProject.projectPlacement.collectKey
          ? 'Zowel afspraak als sleutel nodig'
          : subProject.projectPlacement.appointment
          ? 'Ja, afspraak nodig'
          : subProject.projectPlacement.collectKey
          ? 'Sleutel nodig'
          : subProject.appointmentBlocksTourAssignment
          ? 'Eerst afspraak, opdracht niet in toeren'
          : ''
      }}
    </div>
    <div class="admin-section-arrow">
      <div *ngIf="!client">
        <button mat-icon-button>
          <mat-icon class="admin-section-arrow-icon"> arrow_drop_up </mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!client" [collapse]="appointmentCollapsed" [isAnimated]="!safari">
  <div class="collapse-content-container appointment-collapse-content">
    <mat-card class="top-card mat-elevation-z0 overflowHidden">
      <div
        *ngIf="subProject.projectPlacement != null"
        class="content-container"
      >
        <div>
          <mat-checkbox
            [(ngModel)]="subProject.projectPlacement.appointment"
            (ngModelChange)="save.emit()"
            [class.strong]="subProject.projectPlacement.appointment"
            >Ja, afspraak nodig</mat-checkbox
          >
        </div>
        <div
          class="appointment-sub-block"
          *ngIf="subProject.projectPlacement.appointment"
        >
          <ip-board-appointment
            [project]="project"
            [projectPlacement]="subProject.projectPlacement"
            [hideNeedAppointment]="true"
            [hideNeedAppointmentInfo]="true"
            (save)="save.emit()"
          ></ip-board-appointment>
          <div
            class="textarea-title"
            [ngClass]="appointmentSpecificHour == null ? 'upper-space' : ''"
          >
            Extra info omtrent de afspraak
          </div>
          <textarea-input
            [initContent]="subProject.projectPlacement.needAppointmentInfo"
            [placeholder]="'Extra info'"
            [sensitive]="true"
            (answer)="needAppointmentInfoChanged($event)"
          ></textarea-input>
        </div>
        <div>
          <mat-checkbox
            [(ngModel)]="subProject.projectPlacement.collectKey"
            (ngModelChange)="save.emit()"
            [class.strong]="subProject.projectPlacement.collectKey"
            >Sleutel afhalen</mat-checkbox
          >
        </div>
        <div
          class="appointment-sub-block"
          *ngIf="subProject.projectPlacement.collectKey"
        >
          <div
            class="d-flex"
            [ngClass]="
              subProject.projectPlacement.collectKey ? '' : 'under-space'
            "
          >
            <div class="align-collect-key-from collect-key-from-width">
              <collect-key-from-selector
                [projectPlacement]="subProject.projectPlacement"
                [project]="project"
                (collectKeyFromChanged)="save.emit()"
              ></collect-key-from-selector>
            </div>
          </div>
          <div
            *ngIf="subProject.projectPlacement.collectKeyFrom === -1"
            class="align-collect-key-extra-info-with-selector"
          >
            <textarea-input
              [placeholder]="'Adres noteren + openingsuren'"
              [initContent]="subProject.projectPlacement.collectKeyExtraInfo"
              [sensitive]="true"
              (answer)="collectKeyExtraInfoChange($event)"
            ></textarea-input>
          </div>
          <div
            class="d-flex pb-4 key-mail-container"
            *ngIf="assignedToTour && !executed"
          >
            <div
              [matTooltip]="keyMailTooltip"
              [matTooltipDisabled]="
                !(
                  contactEmail == null ||
                  tourDate == null ||
                  tourPlacerUser == null
                )
              "
              class="d-flex align-items-center"
            >
              <a
                class="click-link btn-accent mat-flat-button mat-button-base btn-key-mail"
                href="{{ mailHtml }}"
                [class.disabled]="
                  contactEmail == null ||
                  tourDate == null ||
                  tourPlacerUser == null
                "
              >
                <div class="d-flex">
                  <mat-icon>email</mat-icon>
                  <span>Verstuur sleutel herinneringsmail</span>
                </div>
              </a>
              <button
                mat-icon-button
                matTooltip="Kopieer email tekst"
                (click)="copyEmailBodyToClipboard()"
                [disabled]="
                  contactEmail == null ||
                  tourDate == null ||
                  tourPlacerUser == null
                "
                class="ml-2"
              >
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
            <div class="ml-4 mt-2">
              <mat-checkbox
                *ngIf="!togglingMailRegistration"
                [(ngModel)]="mailRegistrationChecked"
                (ngModelChange)="collectKeyReminderSend()"
                >Verstuurd</mat-checkbox
              >
              <mat-spinner
                *ngIf="togglingMailRegistration"
                color="primary"
                diameter="24"
              ></mat-spinner>
            </div>
            <div
              *ngIf="
                subProject?.projectPlacement?.collectKeyMailSendRegistration
                  ?.by != null &&
                subProject?.projectPlacement?.collectKeyMailSendRegistration
                  ?.date != null
              "
              class="align-with-registration-checkbox ml-4"
            >
              <i
                >Geregistreerd door
                {{
                  subProject.projectPlacement.collectKeyMailSendRegistration.by
                    ?.firstName
                    | personName
                      : subProject.projectPlacement
                          .collectKeyMailSendRegistration.by?.lastName
                }}
                op
                {{
                  subProject.projectPlacement.collectKeyMailSendRegistration
                    .date | formatDate : '' : 'dd/MM/yyyy HH:mm'
                }}</i
              >
            </div>
          </div>
        </div>

        <div>
          <mat-checkbox
            [(ngModel)]="subProject.appointmentBlocksTourAssignment"
            (ngModelChange)="appointmentBlocksTourAssignmentChanged()"
            [class.strong]="subProject.appointmentBlocksTourAssignment"
            >Eerst afspraak, opdracht niet in toeren</mat-checkbox
          >
        </div>

        <ng-container
          *ngIf="
            subProject.appointmentBlocksTourAssignment ||
            subProject.projectPlacement.appointment ||
            subProject.projectPlacement.collectKey
          "
        >
          <hr />
          <div class="appointment-time">
            <mat-radio-group
              [(ngModel)]="appointmentSpecificHour"
              (ngModelChange)="appointmentSpecificHourChanged()"
            >
              <mat-radio-button [value]="true">
                Specifiek uur
              </mat-radio-button>
              <mat-radio-button class="left-space" [value]="false">
                Gedeelte van de dag
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <mat-form-field *ngIf="appointmentSpecificHour" appearance="outline">
            <input
              matInput
              type="time"
              [ngModel]="getAppointmentTime()"
              placeholder="Selecteer een tijdstip"
              [ngxMatTimepicker]="appointmentTimepicker"
              [format]="24"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="appointmentTimeChanged($event)"
            />
            <ngx-mat-timepicker #appointmentTimepicker></ngx-mat-timepicker>
          </mat-form-field>

          <mat-form-field
            *ngIf="appointmentSpecificHour === false"
            class="appointment-time-of-day-field"
            appearance="outline"
          >
            <input
              matInput
              placeholder="Gedeelte van de dag"
              [(ngModel)]="subProject.projectPlacement.appointmentTimeOfDay"
              (ngModelChange)="save.emit()"
            />
          </mat-form-field>

          <br />
          <div class="textarea-title">Opvolging afspraak intern</div>
          <textarea-input
            [initContent]="subProject.projectPlacement.appointmentFollowUp"
            [placeholder]="'Extra info'"
            [sensitive]="true"
            [client]="true"
            (answer)="appointmentFollowUpChanged($event)"
          ></textarea-input>

          <div *ngIf="subProject.projectPlacement.firstAppointment === false">
            <div class="d-flex">
              <label class="mt-3 mr-5 pr-1">Datum</label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  [matDatepicker]="appointmentFollowUpDatePicker"
                  placeholder="Selecteer een datum"
                  [(ngModel)]="
                    subProject.projectPlacement.appointmentFollowUpDate
                  "
                  (ngModelChange)="save.emit()"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="appointmentFollowUpDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #appointmentFollowUpDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div *ngIf="appointmentEmployeeOptions?.length > 0" class="d-flex">
              <label class="mt-3 mr-2 pr-1">Medewerker</label>
              <mat-form-field appearance="outline">
                <mat-select
                  matInput
                  placeholder="Kies een medewerker"
                  [(ngModel)]="
                    subProject.projectPlacement.appointmentFollowUpEmployee
                  "
                  (ngModelChange)="save.emit()"
                  [compareWith]="compareEntities"
                >
                  <mat-option
                    *ngFor="let option of appointmentEmployeeOptions"
                    [value]="option"
                  >
                    <span>{{
                      option.user?.firstName
                        | personName : option.user?.lastName
                    }}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="upper-space registered-action-display-container">
            <div>
              <mat-checkbox
                [(ngModel)]="subProject.projectPlacement.appointmentReady"
                (ngModelChange)="appointmentReadyChanged()"
                [disabled]="
                  subProject.appointmentBlocksTourAssignment && !assignedToTour
                "
                [matTooltip]="
                  'Job moet aan toer toegewezen zijn alvorens afspraak klaar te kunnen aanduiden'
                "
                [matTooltipDisabled]="
                  !subProject.appointmentBlocksTourAssignment || assignedToTour
                "
              >
                <span class="strong italics-text">Afspraak klaar</span>
              </mat-checkbox>
            </div>
            <div
              *ngIf="
                subProject.projectPlacement.appointmentReadyRegistration != null
              "
              class="align-with-registration-checkbox"
            >
              <i
                >Geregistreerd door
                {{
                  subProject.projectPlacement.appointmentReadyRegistration.by
                    ?.firstName
                    | personName
                      : subProject.projectPlacement.appointmentReadyRegistration
                          .by?.lastName
                }}
                op
                {{
                  subProject.projectPlacement.appointmentReadyRegistration.date
                    | formatDate : '' : 'dd/MM/yyyy HH:mm'
                }}</i
              >
            </div>
          </div>

          <div class="registered-action-display-container">
            <div>
              <mat-checkbox
                [(ngModel)]="subProject.projectPlacement.appointmentFailure"
                (ngModelChange)="appointmentFailureChanged()"
              >
                <span class="strong italics-text">Geen afspraak</span>
              </mat-checkbox>
            </div>
            <div
              *ngIf="
                subProject.projectPlacement.appointmentFailureRegistration !=
                null
              "
              class="align-with-registration-checkbox"
            >
              <i
                >Geregistreerd door
                {{
                  subProject.projectPlacement.appointmentFailureRegistration.by
                    ?.firstName
                    | personName
                      : subProject.projectPlacement
                          .appointmentFailureRegistration.by?.lastName
                }}
                op
                {{
                  subProject.projectPlacement.appointmentFailureRegistration
                    .date | formatDate : '' : 'dd/MM/yyyy HH:mm'
                }}</i
              >
            </div>
          </div>
        </ng-container>
      </div>
    </mat-card>
  </div>
</div>
